module.exports = __webpack_public_path__ + "img/7h.dd07b898.png";